import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface NavbarProps {
  children?: React.ReactNode;
}

export const Navbar: React.FC<NavbarProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  // Determine user type from user object
  const isParent = user?.user_type?.name === 'parent';

  // Navigation links based on user type
  const navLinks = isParent
    ? [{ path: '/parent/home', label: 'Home', icon: '🏠' }]
    : [
        { path: '/student/home', label: 'Home', icon: '🏠' },
        { path: '/progress', label: 'Progress', icon: '📊' },
        { path: '/dashboard', label: 'Dashboard', icon: '📚' },
      ];

  const handleLogout = (): void => {
    void logout();
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <Link
                  to={isParent ? '/parent/home' : '/student/home'}
                  className="text-2xl font-bold text-blue-600"
                >
                  Numbie
                </Link>
              </div>
              <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className={`inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium ${
                      location.pathname === link.path
                        ? 'border-blue-500 text-gray-900'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
                    }`}
                  >
                    <span className="mr-1">{link.icon}</span>
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <span className="text-sm text-gray-700 mr-4">{user?.name || 'Student'}</span>
                <button
                  onClick={handleLogout}
                  className="text-sm text-gray-500 hover:text-gray-700 font-medium"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <main>{children}</main>
    </div>
  );
};

export default Navbar;
